"use client";
import { JSX } from "react";
import EmblaSlider from "../../lib/Embla-slider";
import { TSlideWidith } from "../../lib/Embla-slider/EmblaSliderContainer";
const BlogsCarousel: React.FC<React.PropsWithChildren> = ({ children }) => {
  const gap = 24;
  const data = (children as Array<JSX.Element>) ?? [];
  if (data.length === 0) return null;
  return (
    <EmblaSlider>
      <EmblaSlider.EmblaSliderViewport>
        <EmblaSlider.EmblaSliderContainer
          gap={gap}
          slides={[
            ...(children as Array<JSX.Element>)?.map((child) => ({
              component: child,
              width: "auto" as TSlideWidith,
            })),
          ]}
        />
        <EmblaSlider.EmblaFilters />
        {data?.length > 3 ? <EmblaSlider.EmblaSliderPrevNextButtons /> : <></>}
      </EmblaSlider.EmblaSliderViewport>
    </EmblaSlider>
  );
};

export default BlogsCarousel;
